import { store } from '@core/redux/store';
import { removeAuthToken } from '@features/auth/store/auth.storage';
import axios from 'axios';
import qs from 'qs';

import { normalizeErrorsInterceptor } from '../service/interceptors/normalizeErrorsInterceptor';
import { env } from './env';

const statusCodeUnauthorized = 401;
const statusCodeTimedOut = 408;

export const gameficationApi = axios.create({
  baseURL: env.GAMEFICATION_URL,
  paramsSerializer: params => qs.stringify(params),
  headers: {
    'Content-Type': 'application/json',
  },
});

gameficationApi.interceptors?.request.use(async function (config) {
  const token =
    store.getState().auth.payload?.access_token || store.getState().auth.token;

  config.headers.Authorization = token;
  config.headers['x-tenant-id'] = env.TENANT_ID;
  return config;
});
gameficationApi.interceptors?.response.use(
  response => response,
  error => {
    if (error.response.status === statusCodeUnauthorized) {
      removeAuthToken();
      window.location.href = 'login';
    }

    return error;
  }
);

axios.interceptors?.response.use(
  config => config,
  error => {
    if (
      error.response.status === statusCodeTimedOut ||
      error.code === 'ECONNABORTED'
    ) {
      window.location.href = 'erro';
    }
    return Promise.reject(error);
  }
);

gameficationApi.interceptors?.response.use(
  undefined,
  normalizeErrorsInterceptor
);
